<app-toolbar *ngIf="filter$ | async as filter">
  <app-breadcrumbs>
  </app-breadcrumbs>
  <app-page-search class="me-auto" [(searchString)]="filter.Global" [(showFilters)]="filter.AdvancedFilter" (searchStringChange)="filter$.next(filter)"></app-page-search>
  <app-toolbar-list-buttons (addClick)="edit(null)">
  </app-toolbar-list-buttons>
</app-toolbar>
<p-table styleClass="p-datatable-sm p-datatable-striped"
         [value]="users$ | async"
         sortField="Fullname"
         dataKey="Id"
         [paginator]="true"
         [rows]="50"
         [rowsPerPageOptions]="[10,25,50,100,200]"
         [showCurrentPageReport]="true"
         currentPageReportTemplate="{first} to {last} of {totalRecords}"
         [(first)]="offset"
         [globalFilterFields]="['Fullname', 'Email']"
         (onFilter)="updateFilter($event)">
  <ng-template pTemplate="header">
    <ng-container *transloco="let t; read: 'ime.system.user'">
      <tr>
        <th pSortableColumn="Fullname">
          {{t('Name')}}
          <p-sortIcon field="Fullname"></p-sortIcon>
        </th>
        <th pSortableColumn="Email">
          {{t('Email')}}
          <p-sortIcon field="Email"></p-sortIcon>
        </th>
        <th>{{t('Language')}}</th>
        <th pSortableColumn="IsDeleted">
          {{t('Is deleted')}}
          <p-sortIcon field="Email"></p-sortIcon>
        </th>
      </tr>
      <ng-container *ngLet="filter$ | async as filter">
        <tr *ngIf="filter.AdvancedFilter">
          <th></th>
          <th></th>
          <th>
            <p-columnFilter field="LanguageId" matchMode="equals" [showMenu]="false">
              <ng-template pTemplate="filter" let-filterCallback="filterCallback">
                <ng-select #select class="select-sm form-control" [items]="languagesQuery.getAll$ | async" [(ngModel)]="filter.Data.LanguageId"
                           bindLabel="Code" bindValue="Id" appendTo="body" (change)="filterCallback($event?.Id); filter$.next(filter); select.close()">
                </ng-select>
              </ng-template>
            </p-columnFilter>
          </th>
          <th>
            <p-columnFilter type="boolean" field="IsDeleted"></p-columnFilter>
          </th>
        </tr>
      </ng-container>
    </ng-container>
  </ng-template>
  <ng-template pTemplate="body" let-user>
    <tr>
      <td><a href="javascript:void(0)" (click)="edit(user.Id)">{{user.Fullname}}</a></td>
      <td><a href="javascript:void(0)" (click)="edit(user.Id)">{{user.Email}}</a></td>
      <td>
        <a href="javascript:void(0)" (click)="edit(user.Id)">{{(languagesQuery.getAll$ | async | find: 'Id': user.LanguageId)?.Code}}</a>
      </td>
      <td><a href="javascript:void(0)" (click)="edit(user.Id)">{{user.IsDeleted ? 'Yes' : 'No'}}</a></td>
    </tr>
  </ng-template>
</p-table>
